import { ReactNode, MouseEvent, memo, useState, useEffect } from 'react';
import { Span } from '../../../../../../component/modal/ModalStyle';
import Modal from '../../../../../../component/modal/Modal.component'
import Button from '../../../../../../component/buttton/Button.component';
import GridComponent from "../../../../../../component/grid/GridComponent.component";
import MenuItem from '@material-ui/core/MenuItem';
import { FormInput, FormSelect } from '../../../../../../component/input/InputStyle';
import { Grid } from '@material-ui/core';
import FormLabel from '../../../../../../component/input/FormLabel.component';
import { InterfaceTable, InterfaceTableModal } from '../../interface/InterfaceSchedulingDock';


interface Props {
    children?: ReactNode;
    open: boolean;
    onClickSubmit(newDock: string, newStore: string, newDay: any, newStartDate: string, newEndDate: string, id: number, newStatus: string): void;
    title: string;
    data: InterfaceTableModal;
    dock: InterfaceTable[];
    handleClick(event: MouseEvent<HTMLElement>): void
}



function ModalUpdate({ open, title, onClickSubmit, data, dock, handleClick}: Props) {

    const [valueDockModal, setValueDockModal] = useState('')
    const [valueStoreModal, setValueStoreModal] = useState('');
    const [checkedModal, setCheckedModal] = useState([
        {
            name: 'Todos os dias ', 
            isChecked: false
        },
        {
            name: ' Segunda', 
            isChecked: false
        },
        {
            name: ' Terça', 
            isChecked: false
        },
        {
            name: ' Quarta', 
            isChecked: false
        },
        {
            name: ' Quinta', 
            isChecked: false
        },
        {
            name: ' Sexta', 
            isChecked: false
        },
        {
            name: ' Sábado', 
            isChecked: false
        },
        {
            name: 'Domingo', 
            isChecked: false
        },
    ]);
    const [selectModal, setSelectModal] = useState(false);
    const [id, setId] = useState(Number);
    const [startDateValueModal, setStartTimeValueModal] = useState("");
    const [endDateValueModal, setEndTimeValueModal] = useState("");
    const [valueStatusModal, setValueStatusModal] = useState('');

    const handleChangeModal = (e:any) => {
        const {value, name} = e.target;
        if (name === 'dock') {
            setValueDockModal(value);
        } else if (name === 'store') {
            setValueStoreModal(value);
        } else if (name === 'timeStart') {
            setStartTimeValueModal(value);
        } else if (name === 'timeEnd') {
            setEndTimeValueModal(value);
        } else {
            setValueStatusModal(value);
        }
    }

    const handleChangeDayModal = (e: any) => {
        const { name } = e.target
        const copy = [...checkedModal];
        if (name === 'Todos os dias ') {
            checkedModal.map((change: any, index: number) => {
                copy[index].isChecked = !selectModal
                setCheckedModal(copy)
                /* console.log(index) */
            })  
            setSelectModal(!selectModal)
            /* console.log(checkedModal) */
        }  else {
            const indexCheckbox = checkedModal.findIndex((object: any) => {
                return object.name === name
            })
            if (checkedModal[0].isChecked) {
                copy[indexCheckbox].isChecked = !copy[indexCheckbox].isChecked;
                copy[0].isChecked = false;
                setSelectModal(false);
                setCheckedModal(copy);
            } else {
                copy[indexCheckbox].isChecked = !copy[indexCheckbox].isChecked;
                setCheckedModal(copy);
            }
        }
    };

    useEffect(() => {
        setValueStatusModal(data.Status);
        setValueStoreModal(data.Lojas);
        setValueDockModal(data.Docas);
        setStartTimeValueModal(data.HorarioInicio);
        setEndTimeValueModal(data.HorarioFim);
        setId(data.id)
        setCheckedModal([
            {
                name: 'Todos os dias ', 
                isChecked: false
            },
            {
                name: ' Segunda', 
                isChecked: false
            },
            {
                name: ' Terça', 
                isChecked: false
            },
            {
                name: ' Quarta', 
                isChecked: false
            },
            {
                name: ' Quinta', 
                isChecked: false
            },
            {
                name: ' Sexta', 
                isChecked: false
            },
            {
                name: ' Sábado', 
                isChecked: false
            },
            {
                name: 'Domingo', 
                isChecked: false
            },
        ])
        const copyDays = [...checkedModal];
        if (open === true) {
            if (data.DiaSemana === "Domingo, Segunda, Terça, Quarta, Quinta, Sexta, Sábado") {
                setSelectModal(true)
                copyDays.map((change: any, index: number) => {
                    copyDays[index].isChecked = true
                }) 
                setCheckedModal(copyDays) 
            } else {
                setSelectModal(false)
                const weeks = data.DiaSemana.replace(/\s/g, '').split(',');
                weeks.forEach((day: any) => {
                    const indexTrue = copyDays.findIndex((item: any) =>    
                        item.name.replace(/\s/g, '') === day
                    )
                    /* console.log('index',indexTrue) */
                    copyDays[indexTrue].isChecked = true;
                })
                setCheckedModal(copyDays)
            }
        }
    }, [open]);

            return (
                <Modal size={'xl'} open={open} handleClick={() => {}} >
                    <Span style={{textAlign:"center"}}>{title.toLocaleUpperCase()}</Span>
                    <GridComponent margin="10px auto 10px auto" spacing={2}>
                        <FormLabel title='Doca' sm={2} md={2}>
                            <FormSelect value={valueDockModal} name='dock' onChange={handleChangeModal}>
                                {dock.map((item:InterfaceTable,index:number)=>(
                                    <MenuItem key={index} value={item.id}>{item.id}</MenuItem>
                                ))}
                            </FormSelect>
                        </FormLabel>
                        <FormLabel title='Loja' sm={2} md={2}>
                            <FormInput value={valueStoreModal} name='store' onChange={handleChangeModal}></FormInput>
                        </FormLabel>
                        <FormLabel title='Dias da semana' sm={4} md={4}>
                            <ul style={{margin: '0 auto', padding: '0px'}}>
                                {checkedModal.map((day: any, index: number) => (
                                    <div style={{display: 'inline', marginLeft: '8px', textAlign: 'center'}}>
                                        <label key={index} htmlFor={day.name}>{day.name}
                                        <input type="checkbox" name={day.name} id={day.name} value={day.name} checked={checkedModal[index].isChecked} onChange={handleChangeDayModal}/>
                                        </label>
                                    </div>
                                ))}
                            </ul>
                        </FormLabel>
                        <FormLabel title='Horário' sm={2} md={2}>
                            <span>Horário de Inicio</span>
                            <input
                                type='time'
                                name='timeStart'
                                value={startDateValueModal}
                                onChange={handleChangeModal}
                            ></input>
                            <span>Horário Fim</span>
                            <input
                                type='time'
                                name='timeEnd'
                                value={endDateValueModal}
                                onChange={handleChangeModal}
                            ></input>
                        </FormLabel>
                        <FormLabel required sm={2} md={2} title='Status'>
                            <FormSelect value={valueStatusModal} name='status' onChange={handleChangeModal}>
                                    <MenuItem value={'Disponível'}>Disponível</MenuItem>
                                    <MenuItem value={'Indisponível'}>Indisponível</MenuItem>
                            </FormSelect>
                        </FormLabel>
                        <Grid item margin="0 auto" xs={6}>
                            <Button title='Ok' size='small' onClick={()=> onClickSubmit(valueDockModal, valueStoreModal, checkedModal, startDateValueModal, endDateValueModal, id, valueStatusModal)} fullWidth />
                        </Grid>
                        <Grid item margin="0 auto" xs={6}>
                            <Button title='Fechar' size='small' onClick={handleClick} fullWidth />
                        </Grid>
                    </GridComponent>
                </Modal>
            );
}

export default memo(ModalUpdate);